export const leaveApprovalsRoute = '/leave-approvals';

export const getLeaveApprovalsTabsRoute = (tab: 'todo' | 'done' = 'todo') => {
  return `${leaveApprovalsRoute}/${tab}` as const;
};
